import { render, staticRenderFns } from "./createSmallInstitution.vue?vue&type=template&id=771a70db&scoped=true&"
import script from "./createSmallInstitution.vue?vue&type=script&lang=js&"
export * from "./createSmallInstitution.vue?vue&type=script&lang=js&"
import style0 from "./createSmallInstitution.vue?vue&type=style&index=0&id=771a70db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771a70db",
  null
  
)

export default component.exports